<template>
  <div>
    <preview-frame :task-id="id" type="result"></preview-frame>
    <div class="congratulation">
      <h2>Congratulations!</h2>
      <small v-if="points > 0" class="points">+{{ points }} points</small>
      <small v-else>You have already complete this task</small>
    </div>
    <div class="task-result-buttons" v-if="!isLoading">
      <div class="center-obj" v-if="task.level < levelsCount">
        <button class="btn btn-blue" v-on:click="nextToLevel">Next level</button>
      </div>
      <div class="center-obj">
        <button class="btn btn-blue" v-on:click="nextToProfile">To Profile</button>
      </div>
    </div>
  </div>
</template>

<script>
    import {GET_TASK, TASK_PLAYGROUND_REQUEST, USER_TASK_START} from "../../../store/actions/task";
    import PreviewFrame from "../../../components/task/PreviewFrame";

    export default {
        name: "Result",
        components: {PreviewFrame},
        props: ['courseId', 'id', 'points'],
        data() {
            return {
                isLoading: true,
                task: {
                    level: 0,
                    ended: false
                },
            };
        },
        created() {
            this.$store.dispatch(TASK_PLAYGROUND_REQUEST, this.id).then(taskPlayground => {
                this.taskPlayground = taskPlayground;
            });

            this.$store.dispatch(GET_TASK, this.id).then(task => {
                this.task = task;
                this.isLoading = false;
            });

            this.prepareData(this.$store.getters.getTasks);
        },
        methods: {
            prepareData(tasks) {
                if (tasks.length <= 0) return;

                if (tasks.find(task => task.id === this.id) === undefined)
                    this.$router.push({
                        name: "NotFound",
                    });
                else {
                    this.task = tasks.find(task => task.id === this.id);
                    this.isLoading = false;
                }
            },
            nextToProfile() {
                this.$router.push({
                    name: 'Profile'
                });
            },
            nextToLevel() {
                this.$router.push({
                    name: 'TaskTheory',
                    params: {
                        courseId: this.courseId,
                        id: this.$store.getters.getTasks.find(task => task.level === (this.task.level + 1)).id
                    }
                });
            }
        },
        computed: {
            levelsCount() {
                return Math.max.apply(
                    Math,
                    this.$store.getters.getTasks.map(function (task) {
                        return task.level;
                    })
                );
            },
        },
    };
</script>

<style scoped></style>
